import script from "./CardCotizacionTotales.vue?vue&type=script&setup=true&lang=js"
export * from "./CardCotizacionTotales.vue?vue&type=script&setup=true&lang=js"

import "./CardCotizacionTotales.vue?vue&type=style&index=0&id=ce6ca32e&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/Proyectos/Vue/cotizador-ventus/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ce6ca32e"]])

export default __exports__